<template>
  <div class="fts-lobby">
    <div class="lobby-content">
      <div class="lobby-greeting">
        <div class="lobby-greeting-title">
          Welcome,
          <span>{{userProfileName}}</span>
        </div>
      </div>

      <div class="lobby-waiting-card">
        <div class="lobby-waiting-card-icon">
          <font-awesome-icon :icon="['far', 'hourglass']" />
        </div>

        <div class="lobby-waiting-card-message">
          You're in the lobby. Please wait while the workspace owner reviews your request to join and grants access.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authorizationStore } from '../store/authorizationStore';
import { clientStore } from '../store/clientStore';

export default {
  computed: {
    workspaceLobby() {
      return clientStore.getters.workspaceLobby;
    },
    userProfileName() {
      return authorizationStore.getters.userProfile.displayName;
    }
  },
  watch: {
    workspaceLobby(val) {
      if (!val) {
        this.$router.replace({ name: "lite" });
      }
    }
  },
  mounted() {
    if (!this.workspaceLobby) {
      this.$router.replace({ name: "lite" });
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-lobby {
  .lobby-content {
    margin: 0 1rem 1rem;
    color: var(--inistate-text-primary);
  }
  .lobby-greeting {
    margin-bottom: 2rem;
  }
  .lobby-greeting-title {
    font-weight: var(--inistate-font-weight-medium);
    font-size: var(--inistate-heading-text-18);
    line-height: var(--inistate-heading-text-18--line-height);
  }
  .lobby-waiting-card {
    max-width: 100%;
    width: 600px;
    margin-left: auto;
    margin-right: auto;
    padding: 1.5rem;
    border: 1px solid var(--inistate-border-primary);
    border-radius: var(--inistate-rounded-8);
    box-shadow: var(--fts-elevation-1);
    text-align: center;
  }
  .lobby-waiting-card-icon {
    height: 4rem;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    margin-left: auto;
    margin-right: auto;
    font-size: var(--inistate-heading-text-32);
  }
  .lobby-waiting-card-message {
    max-width: 24rem;
    margin-left: auto;
    margin-right: auto;
    font-size: var(--inistate-paragraph-text-16);
    line-height: var(--inistate-paragraph-text-16--line-height);
  }

  /* ---- Calm density — P1 (2026-09-05, round 4, L1a):
     docs/frontend-lite-pages-calm-density-proposal.md. The waiting card becomes a 36px row on a
     hairline; greeting 15/600. Class-level only. ---- */
  .lobby-content { margin: 12px 24px; }
  .lobby-greeting { margin-bottom: 12px; }
  .lobby-greeting-title {
    font-size: 0.9375rem;
    line-height: 20px;
    font-weight: 600;
  }
  .lobby-waiting-card {
    width: auto;
    max-width: 640px;
    min-height: 36px;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: left;
    border: 0;
    border-bottom: 1px solid var(--fts-gray-100);
    border-radius: 0;
    box-shadow: none;
  }
  .lobby-waiting-card-icon {
    height: 16px;
    width: 16px;
    margin: 0;
    font-size: 16px;
    color: var(--fts-default);
  }
  .lobby-waiting-card-message.lobby-waiting-card-message {
    max-width: none;
    margin: 0;
    font-size: 0.8125rem;
    line-height: 20px;
    color: var(--fts-text);
  }
}
</style>